
























import { Produto, ProdutosService } from "@/services/produtos.service";
import { Component } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import ImageCropper from "@/shared/components/image-cropper.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: {
    Loading,
    ImageCropper,
  },
})
export default class AlterarImagem extends mixins(GlobalMixin) {
  loading = false;
  produto: Produto | null = null;
  base64 = "";
  mounted() {
    this.fetchProduto();
  }

  get idProduto() {
    return this.$route.params.id;
  }

  get idCatalogo() {
    return this.$route.params.idCatalogo;
  }

  get imageUrl() {
    if (
      this.produto &&
      this.produto.imagensProduto &&
      this.produto.imagensProduto[0]
    ) {
      return this.produto.imagensProduto[0].nomeArquivo;
    }

    return null;
  }

  async fetchProduto() {
    this.startLoader();
    this.produto = await ProdutosService.obterProduto(this.idProduto).finally(
      this.stopLoader
    );
  }
  async salvar() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      if (this.produto && this.produto.idProduto) {
        this.startLoader();
        await ProdutosService.alterarImagem(
          this.produto.idProduto,
          this.base64
        ).finally(this.stopLoader);
        this.$router.push({
          name: "catalogos-produtos",
          params: { idCatalogo: this.idCatalogo },
        });
      }
    }
  }
}
